













import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import FileSearch from "@/components/file/FileSearch.vue";
import ListView from "@/components/file/FileList.vue";
import FileUpload from "@/components/file/FileUpload.vue";
import Pager from "@/components/Pager.vue";
import { ScheduleView } from "@/store/modules/enums";
import { FileFilter } from "@/store/modules/types";

@Component({
    components: {
        BPagination,
        Header,
        EntityTabs,
        FileSearch,
        ListView,
        FileUpload,
        Pager
    },
    computed: {
        ...mapState("schedule", ["list"]),
    },
})
export default class File extends Vue {
    filter = this.defaultFilter();
    @Watch("list.filter", { deep: true })
    onFilterChanged() {
        this.getFiles();
    }

    pageRows: Array<any> = [];
    totalRows: number = 0;
    list!: any;
    selected: any | null = null;

    defaultFilter(): FileFilter {
        return {
            name: "",
            pageNumber: 1,
            rowsPerPage: 25
        }

    }
    async getFiles() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            const data = await this.$store.dispatch("schedule/getFileList", this.filter);
            this.totalRows = data.totalRows;
            this.pageRows = data.pageRows;
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    clear() {
        this.filter = this.defaultFilter();
        this.getFiles();
    }
    showLog(appt: any) {
        this.selected = appt;
        this.$modal.show("appt-log");
    }
    get ScheduleView() {
        return ScheduleView;
    }

    rowsPerPageChanged(rowsPerPage: number) {
        this.filter.rowsPerPage = rowsPerPage;
        this.getFiles();
    }
    pageChanged(page: number) {
        this.filter.pageNumber = page;
        this.getFiles();
    }
    mounted() {
        this.filter = this.defaultFilter();
        this.getFiles();
    }
}
